import {
  AUTOCOMPLETE_CLIENTS_SUCCESS,
  AUTOCOMPLETE_CLIENTS,
  AUTOCOMPLETE_MY_CLIENTS_SUCCESS,
  AUTOCOMPLETE_MY_CLIENTS,
  CLEAR_AUTOCOMPLETE_CLIENTS,
  SEARCH_CLIENTS_SUCCESS,
  SEARCH_CLIENTS,
  SEARCH_MY_CLIENTS,
  SEARCH_MY_CLIENTS_SUCCESS,
  EXPORT_MY_CLIENTS,
  EXPORT_MY_CLIENTS_SUCCESS,
  EXPORT_MY_CLIENTS_ERROR,
} from '../constants/ActionsTypes'

export const searchClients = (params) => {
  return {
    type: SEARCH_CLIENTS,
    payload: params,
  }
}

export const searchClientsSuccess = (data) => {
  return {
    type: SEARCH_CLIENTS_SUCCESS,
    payload: data,
  }
}

export const autocompleteClients = (params) => {
  return {
    type: AUTOCOMPLETE_CLIENTS,
    payload: params,
  }
}

export const autocompleteClientsSuccess = (data) => {
  return {
    type: AUTOCOMPLETE_CLIENTS_SUCCESS,
    payload: data,
  }
}

export const autocompleteMyClients = (params) => {
  return {
    type: AUTOCOMPLETE_MY_CLIENTS,
    payload: params,
  }
}

export const autocompleteMyClientsSuccess = (data) => {
  return {
    type: AUTOCOMPLETE_MY_CLIENTS_SUCCESS,
    payload: data,
  }
}

export const clearAutocompleteClients = () => {
  return {
    type: CLEAR_AUTOCOMPLETE_CLIENTS,
  }
}

export const searchMyClients = (params) => {
  return {
    type: SEARCH_MY_CLIENTS,
    payload: params,
  }
}

export const searchMyClientsSuccess = (data) => {
  return {
    type: SEARCH_MY_CLIENTS_SUCCESS,
    payload: data,
  }
}

export const exportMyClients = (params) => ({
  type: EXPORT_MY_CLIENTS,
  payload: params,
})

export const exportMyClientsSuccess = () => ({
  type: EXPORT_MY_CLIENTS_SUCCESS,
})

export const exportMyClientsError = (error) => ({
  type: EXPORT_MY_CLIENTS_ERROR,
  payload: error,
})
